module.exports = __webpack_public_path__ + "static/media/nutrition.c7ecfc6b.png";